import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

export const NotFoundScreen: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', padding: '40px' }}>
            <style>
                {`
                @keyframes float-404 {
                    0% { transform: translateY(0px); }
                    50% { transform: translateY(-20px); }
                    100% { transform: translateY(0px); }
                }
                .animated-404 .ant-result-image {
                    animation: float-404 4s ease-in-out infinite;
                }
                `}
            </style>
            <Result
                className="animated-404"
                status="404"
                title="404"
                subTitle="Sorry, the page you visited does not exist or has been moved."
                extra={
                    <Button type="primary" onClick={() => navigate('/dashboard')}>
                        Back to Dashboard
                    </Button>
                }
            />
        </div>
    );
};
